<template>
  <div class="offer">
    <v-modal :modalName="modalName" class="offer__container">
      <template slot="header">
        <div class="offer__container__header">
          <div class="offer__container__header__overlay"></div>
          <span class="offer__container__header__title">{{offer.title}}</span>
          <v-img :src="createImageUrl(offer)" class="offer__container__header__img" />
          <v-btn text large fab @click="toggleOfferModal()" class="offer__container__header--close">
            <font-awesome-icon icon="times" />
          </v-btn>
        </div>
      </template>
      <template slot="body">
        <div class="offer__container__body">
          <div class="offer__container__body__content">
            <v-img :src="createMerchantUrl(offer)" class="offer__container__body__logo" />
            <span class="offer__container__body__merchant">{{offer.merchant.name}}</span>

            <span class="offer__container__body__content--description">{{offer.description}}</span>
          </div>
          <v-divider />
        </div>
      </template>
      <template slot="footer">
        <div class="offer__container__footer"></div>
      </template>
    </v-modal>
  </div>
</template>


//     <v-card class="grey lighten-4 pa-0">
//       <v-img :src="image" :max-height="100" width="100%">
//         <div style="display: flex; justify-content: space-between;">
//           <!-- <v-btn
//           fab
//           small
//           dark
//           color="purple"
//           class="ma-3"
//           elevation="5"
//           @click="back"
//         >
//           <font-awesome-icon icon="angle-left" />
//           </v-btn>-->

//           <v-btn
//             text
//             fab
//             style="position: relative; top: 50px;"
//             @click="likeOffer"
//             :class="[like ? 'favourite' : 'white--text']"
//           >
//             <font-awesome-icon icon="heart" />
//           </v-btn>
//         </div>
//       </v-img>

//       <v-card tile class="white">
//         <div style="display:flex; justify-content:left;">
//           <v-img
//             :src="createMerchantUrl(offer.merchant)"
//             max-width="40"
//             class="ma-4"
//           />

//           <div style="position: relative; top: 10px;">
//             {{ offer.title }}
//             <p class="grey--text">{{ offer.merchant.name }}</p>
//           </div>
//         </div>
//         <v-divider></v-divider>

//         <div style="display: flex; justify-content: space-around;">
//           <v-btn text @click="flag" :class="{ flagged: setFlag }">
//             <font-awesome-icon icon="flag" />
//           </v-btn>
//           <v-btn text @click="downvote()" :class="{ downvote: down }">
//             <font-awesome-icon icon="thumbs-down" />
//           </v-btn>
//           <v-col>{{ counter }}</v-col>
//           <v-btn text v-model="up" @click="upvote()" :class="{ upvote: up }">
//             <font-awesome-icon icon="thumbs-up" />
//           </v-btn>
//           <v-btn text>
//             <font-awesome-icon icon="share-alt" />
//           </v-btn>
//         </div>
//         <v-divider></v-divider>

//         <p style="font-size: 12px;" class="pt-3 px-3 grey--text">
//           {{ offer.description }}
//         </p>
//       </v-card>

//       <v-card tile class="ma-3" style="height: 300px;">
//         <offerLocation :offer="offer" name="offer" />
//       </v-card>

//       <div style="display: flex; justify-content: space-around;">
//         <v-btn text tile :href="offer.merchant.url">
//           <font-awesome-icon icon="globe-americas" class="mr-2" />Website
//         </v-btn>
//         <v-btn text tile>
//           <font-awesome-icon icon="qrcode" class="mr-2" />Scan code
//         </v-btn>
//       </div>
//       <v-card>
//         <p style="font-size: 10px;">{{ offer.terms }}</p>
//       </v-card>
//     </v-card>
//   </div>
// </template>

<script>
import OfferLocation from "@/components/offer/offerLocation";
import VModal from "@/components/VModal";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    OfferLocation,
    VModal
  },

  data() {
    return {
      modalName: "offer",

      offer: {}
    };
  },

  computed: {
    downvote() {
      this.counter--;
      this.down = !this.down;
    },

    upvote() {
      this.counter++;
      this.up = !this.up;
    },

    limitedDescription() {
      if (this.offer.description.length > 256) {
        return this.offer.description.substring(0, 256) + "...";
      }
    }
  },

  methods: {
    ...mapActions({ toggleOfferModal: "ui/offerModalState" }),

    back() {
      this.$emit("back");
    },

    likeOffer() {
      this.like = !this.like;
    },

    flag() {
      this.setFlag = !this.setFlag;
    },

    createImageUrl(offer) {
      return `${process.env.VUE_APP_IMAGE_URL}/offer/${offer.id}_${offer.image}`;
    },

    createMerchantUrl(offer) {
      return `${process.env.VUE_APP_IMAGE_URL}/merchant/${offer.merchant.id}_${offer.merchant.logo}`;
    }
  },

  computed: {
    ...mapState({ ui: state => state.ui, offers: state => state.offers })
  },

  mounted() {
    this.offer = this.offers.offer;

    console.log(document.getElementsByClassName("description").innerText);
  }
};
</script>

<style lang="sass" scoped>
@import @/styles/variables.sass
@import @/styles/mixins.sass
@import @/styles/base.sass

.offer
  position: fixed
  width: 100%
  height: 100%
  left: 0
  top: 0
  display: flex
  flex-flow: column
  justify-content: center
  backdrop-filter: blur(4px)
  background: rgba($c-black, .3)
  z-index: 100

  &__container
    display: flex
    flex-flow: column
    width: 420px
    transform: scale(.8)
    border-radius: 15px
    box-shadow: -2px -1px 5px rgba(0, 0, 0, .3)
    overflow-x: hidden !important

    @include for-size(phone-only)
      transform: scale(.8)

    // HEADER

    &__header
      height: 150px

      &__title
        position: absolute
        top: 120px
        left: 80px
        z-index: 20
        font:
          size: 20px
          weight: bold
        color: $c-white

      &__overlay
        z-index: 20
        position: absolute
        left: 0
        height: 150px
        width: 100%
        backdrop-filter: blur(3px)
        background-image: linear-gradient(to bottom, rgba($c-white, .3), rgba($c-black, .2))

      &__img
        height: 100%
        border-top:
          left-radius: 15px
          right-radius: 15px

      &--close
        position: absolute
        top: -10px
        left: 360px
        transition: .3s color ease
        z-index: 20

    // BODY

    &__body
      display: flex
      flex-flow: column
      align-items: center
      border: 1px solid black
        
      &__logo
        position: relative
        top: 0
        border-radius: 50%
        transform: scale(.1)

        &__merchant

        &--description
          width: 30px

</style>
